export default __webpack_public_path__ + "static/2-f00435006736339249c05a284b8c74e0.png";